// Line Item Form — budget & pricing
export const MIN_LINE_ITEM_BUDGET_OVERRIDE_LD_FLAG =
  'release-26.6-account-manager-min-line-item-budget-override-enabled';

// Ad Gallery — Creative Studio label
// TODO [ssat-19135]: Temporary release flag — remove hook/allowlist entries and always render label when isDisneyAi is true.
export const CREATIVE_STUDIO_LABEL_ENABLED_FLAG = 'release-ssat-19135-creative-studio-label-enabled';

// TODO [ssat-18596]: Temporary release flag — remove after this feature is released.
export const CAMPAIGN_TIMEZONE_FULL_ALLOWLIST_FLAG = 'release-ssat-18592-campaign-timezone-full-allowlist';

// Forgot Password — silent invite resend for users who never completed onboarding
// TODO [ssat-17771]: Temporary release flag - remove hook/allowlist entries and always run the
// silent resend once the feature is enabled in PROD and QA-validated.
export const INVITE_RESEND_ENABLED_FLAG = 'dcm-resend-email-for-failed-onboarding';

// New Ad Gallery — inline creative name edit on Ad Details
// TODO [ssat-20339]: Remove when the edit affordance is fully rolled out. See
// docs/business-logic/new-ad-gallery-creative-name-edit/README.md
export const AD_GALLERY_CREATIVE_NAME_EDIT_FLAG = 'ssat-20339-new-ad-gallery-ad-selector-creative-name-edit';

// Analytics — Amplitude event tracking
export const DCM_AMPLITUDE_ENABLED_FLAG = 'dcm-amplitude-enabled';

// Line Item Form — Ad Format popup, Video Plus format
export const AD_FORMAT_POPUP_VIDEO_PLUS_FLAG = 'ad-format-popup-video-plus';

// New Ad Gallery — VAST creative flow (upload + details modal)
// TODO [ssat-20423]: Remove when VAST flow is fully rolled out. See docs/business-logic/new-ad-gallery-vast-flow/README.md
export const NEW_AD_GALLERY_VAST_FLOW_FLAG = 'ssat-20423-new-ad-gallery-vast-flow';

// Campaigns — Ad Format filter on the campaigns list and admin campaigns list
// TODO [ssat-20348]: Remove when the Ad Format filter is fully rolled out.
export const CAMPAIGNS_AD_FORMAT_FILTER_FLAG = 'ssat-20348-campaigns-ad-format-filter';

// Line Item Form — Marketer override validation (SSAT-20355) and admin Campaigns table
// (SSAT-20251). Flag ON extends the budget-minimum override from KERV-only to KERV + Ad Selector
// (CHOICE), reading `hasAdvancedOverride` instead of the legacy `hasKervOverride`.
// TODO [ssat-20355]: Remove once Advanced Override is fully rolled out for all advanced formats.
export const UNIFIED_ADVANCED_OVERRIDE_LD_FLAG = 'unified-advanced-override-feature-enabled';

// New Ad Gallery + Line Item Form — "Try Creative Studio" button
// TODO [ssat-20313]: Remove when the button is fully rolled out — drop the hook and the allowlist entries.
export const TRY_CREATIVE_STUDIO_BUTTON_FLAG = 'ssat-20313-try-creative-studio-button';

// Line Item Form + New Ad Gallery — Ad Selector for 3P- and Nielsen-billed ad accounts.
// Flag ON enables Ad Selector for 3P/Nielsen; flag OFF hides it. 1P always has Ad Selector. KERV/standard on 3P remain VAST-only via AdsControl.
// TODO [SSAT-20958]: Remove when Ad Selector is fully rolled out for 3P/Nielsen billed ad accounts.
export const AD_SELECTOR_3P_BILLED_AD_ACCOUNTS_ENABLED_FLAG = 'ssat-20958-ad-selector-3-p-billed-ad-accounts-enabled';
